module.exports = __webpack_public_path__ + "static/media/privacy-policy.bda158bf.png";